import { feedback, communityFeedback } from './endpoints'
import { authCall } from '.'
import useSWR from 'swr'
import { FeedbackRequest, FeedbackResponse, AppFeedbackResponse } from '../interfaces/feedback'

interface FeedbackListQuery {
  page?: number
  limit?: number
  estateId?: string
}

const FeedbackService = {
  useGetFeedbacks: ({ page = 1, limit = 10, estateId }: FeedbackListQuery = {}) => {
    const url = estateId ? `${communityFeedback(estateId)}?page=${page}&limit=${limit}` : `${feedback}?page=${page}&limit=${limit}`

    return useSWR<AppFeedbackResponse>(
      url,
      async () => {
        const res = await authCall<{ success: boolean; message: string; data: AppFeedbackResponse }>({
          url,
          method: 'get'
        })
        return res.data
      },
      {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        revalidateOnReconnect: true,
        dedupingInterval: 2000,
      }
    )
  },

  submitFeedback: async (data: FeedbackRequest) => {
    const res = await authCall<FeedbackResponse>({
      url: feedback,
      method: 'post',
      data,
    })
    return res
  },
}

export default FeedbackService